export default [
  {
    path: "/course/home",
    name: "course_home",
    component: () => import("pages/course/home"),
    meta: {
      title: "朗朗首页",
    },
  },
  {
    path: "/course/manage",
    name: "course_manage",
    component: () => import("pages/course/manage"),
    meta: {
      title: "班级管理",
    },
  },
  {
    path: "/course/after",
    name: "course_after",
    component: () => import("pages/course/afterClass"),
    meta: {
      title: "课后管理",
    },
  },
];
